<template>
  <div class="ContrastReportThird">
    <div>
      对比限制：
      <a-radio-group v-model="contrastDimension" @change="radioChange" :disabled="IsDetails">
        <a-radio :value="0">同任务</a-radio>
        <a-radio :value="1">同能力</a-radio>
      </a-radio-group>
    </div>
    <a-table
      style="margin-top: 30px"
      :columns="columns"
      rowKey="courseChildId"
      @expandedRowsChange="expandedRowsChange"
      :expandedRowKeys="tableExpandedRowKeys"
      :pagination="tableRelevant.tablePagination"
      :loading="tableRelevant.tableLoading"
      :locale="tableRelevant.locale"
      :dataSource="tableRelevant.tableDataSource"
    >
      <a-table
        slot="expandedRowRender"
        slot-scope="parentText"
        rowKey="id"
        :loading="parentText.childTableLoading"
        :columns="innerColumns"
        :data-source="parentText.details"
        :pagination="false"
      >
        <div slot="abilityTypeName" slot-scope="text, record">
          <div class="self_td" v-for="item in record.abilityDetails" :key="item.id">{{ item.abilityTypeName }}</div>
        </div>
        <div slot="firstAbilityName" slot-scope="text, record">
          <div class="self_td" v-for="item in record.abilityDetails" :key="item.id">
            {{ item.firstAbilityName }}
          </div>
        </div>
        <div slot="secondAbilityName" slot-scope="text, record">
          <div class="self_td" v-for="item in record.abilityDetails" :key="item.id">
            {{ item.secondAbilityName }}
          </div>
        </div>
        <div slot="scoreSwitch" slot-scope="text, record">
          <div class="self_td" v-for="item in record.abilityDetails" :key="item.id">
            <a-switch checked-children="开" un-checked-children="关" :disabled="IsDetails" :checked="item.scoreSwitch" @click="ScoreSwitchChange(record, item)" />
          </div>
        </div>
      </a-table>
    </a-table>
  </div>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'

const columns = [
  { title: '测评轮次', dataIndex: 'sampleName' },
  { title: '机构名称', dataIndex: 'organizationName' },
  { title: '课程名称', dataIndex: 'organizationCourseName' },
  { title: '资源名称', dataIndex: 'courseName' },
  { title: '课时名称', dataIndex: 'courseSessionResourceName' },
  { title: '参与人数', dataIndex: 'userCount' },
]
const innerColumns = [
  { title: '任务名称', key: 'contentName', dataIndex: 'contentName' },
  {
    title: '能力类型',
    key: 'abilityTypeName',
    class: 'testClass',
    align: 'center',
    scopedSlots: { customRender: 'abilityTypeName' },
  },
  {
    title: '一级能力',
    key: 'firstAbilityName',
    class: 'testClass',
    align: 'center',
    scopedSlots: { customRender: 'firstAbilityName' },
  },
  {
    title: '二级能力',
    key: 'secondAbilityName',
    class: 'testClass',
    align: 'center',
    scopedSlots: { customRender: 'secondAbilityName' },
  },
  {
    title: '算分开关',
    key: 'scoreSwitch',
    class: 'testClass',
    align: 'center',
    scopedSlots: { customRender: 'scoreSwitch' },
  },
  { title: '参与人数', key: 'contentpeopleCount', dataIndex: 'contentpeopleCount' },
]
export default {
  name: 'ContrastReportThird',
  props: {
    IsDetails: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      columns,
      tableRelevant: tableRelevant.call(this),
      tableExpandedRowKeys: [], //表格展开的行
      innerColumns,
      contrastDimension: 0,
      ReportInfo: this.$store.getters['organization/getReportInfo'],
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    // 展开行
    expandedRowsChange(expandedRowKeys) {
      this.tableExpandedRowKeys = expandedRowKeys
    },
    getList() {
      this.$http.ReportService.GetGroupReportProjectCoursechildDetail(this.ReportInfo.id).then((res) => {
        const { data, message } = res
        const resultData = []
        data.forEach((item) => {
          const mapSampId = {}
          if (item.groupCourseInfos) {
            item.groupCourseInfos.forEach((v) => {
              if (mapSampId[v.groupReportSampleId]) {
                return
              }
              resultData.push(Object.assign({ ...item }, v))
              mapSampId[v.groupReportSampleId] = true
            })
          }
        })
        this.tableRelevant.tableDataSource = [...resultData]
        this.contrastDimension = this.tableRelevant.tableDataSource[0].contrastDimension
        this.tableExpandedRowKeys = data.map((m) => m.courseChildId)
        this.tableRelevant['tableDataSourceCopy'] = JSON.stringify(resultData)
        if (this.contrastDimension == 0) {
          this.radioChange()
        } else {
          this.radioChange({ target: { value: 1 } })
        }
      })
    },
    getContents(expanded, record) {},
    radioChange(val) {
      this.tableRelevant.tableDataSource = JSON.parse(this.tableRelevant.tableDataSourceCopy)
      const SampleArray = []
      this.tableRelevant.tableDataSource.forEach((f) => {
        let isPush = false
        for (let i = 0; i < SampleArray.length; i++) {
          if (SampleArray[i][0] && SampleArray[i][0].groupReportSampleId === f.groupReportSampleId) {
            SampleArray[i].push(f)
            isPush = true
            break
          }
        }
        if (!isPush) {
          SampleArray.push([f])
        }
      })
      if (SampleArray.length < 2) {
        return
      }
      if (!val || !val.target.value) {
        // 筛选出每个轮次的所有游戏
        const ContentSampleArray = SampleArray.map((m) => {
          let ability = []
          for (let i = 0; i < m.length; i++) {
            ability = ability.concat(m[i].details, [])
          }
          return ability
        })
        this.tableRelevant.tableDataSource = this.tableRelevant.tableDataSource.map((m) => {
          m.details = m.details.filter((f) => {
            // 查找非当前轮次内是否包含相同游戏 qualified数组全部为true，则其他轮次都包含有此游戏
            let qualified = Array.from({ length: SampleArray.length - 1 }).map((m) => false),
              index = 0
            for (let i = 0; i < SampleArray.length; i++) {
              if (SampleArray[i][0].groupReportSampleId !== m.groupReportSampleId) {
                qualified[index++] = indexOf(ContentSampleArray[i], 'contentName', f.contentName) > 0
              }
            }
            return qualified.every((e) => e)
          })
          return m
        })
      } else {
        // 筛选出每个轮次的所有能力
        const AbilitySampleArray = SampleArray.map((m) => {
          let ability = []
          for (let i = 0; i < m.length; i++) {
            ability = ability.concat(
              m[i].details.reduce((pre, cur) => {
                return pre.concat(cur.abilityDetails)
              }, [])
            )
          }
          return ability
        })
        this.tableRelevant.tableDataSource = this.tableRelevant.tableDataSource.map((m) => {
          m.details = m.details.filter((f) => {
            f.abilityDetails = f.abilityDetails.filter((f1, fi1) => {
              let qualified = Array.from({ length: SampleArray.length - 1 }).map((m) => false),
                index = 0
              for (let i = 0; i < SampleArray.length; i++) {
                if (SampleArray[i][0].groupReportSampleId !== m.groupReportSampleId) {
                  qualified[index++] = indexOf(AbilitySampleArray[i], 'firstAbilityName', f1.firstAbilityName) > 0
                }
              }
              return qualified.every((e) => e)
            })
            return f.abilityDetails.length
          })
          return m
        })
      }

      function indexOf(arr, key, value) {
        let index = 0
        for (let j = 0; j < arr.length; j++) {
          if (arr[j][key] === value) {
            index++
          }
        }
        return index
      }
    },
    // 编辑算分开关
    ScoreSwitchChange(record, item) {
      item.scoreSwitch = !item.scoreSwitch
    },
  },
}
</script>

<style scoped>
::v-deep .ant-table-tbody .testClass {
  padding: 0 !important;
}

.self_td {
  height: 54px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  justify-content: center;
}
</style>
